(function ($) {
  Drupal.behaviors.belle_formatter = {
    attach: function (context) {
      $('.belle_formatter', context).once(function () {
        // Fade in modules for this boutique.
        var hasFadedMod3, hasFadedMod4, hasFadedMod5, hasFadedMod6;

        hasFadedMod3 = hasFadedMod4 = hasFadedMod5 = hasFadedMod6 = false;
        var offsetVal = -200;
        var mod3 = $('#belle_mod3');
        var triggerMod3 = '#belle_mod3';
        var mod4 = $('#belle_mod4');
        var triggerMod4 = '#belle_mod4';
        var mod5 = $('#belle_mod5');
        var triggerMod5 = '#belle_mod5';
        var mod6 = $('#belle_mod6');
        var triggerMod6 = '#belle_mod6';

        // Fade in modules for this boutique.
        $('#belle_mod3, #belle_mod4, #belle_mod5, #belle_mod6').addClass('hideModules');

        function checkForIE() {
          // Check for Windows.
          if (navigator.platform === 'Win32') {
            $('body').addClass('isWin');
          }
        }

        function checkForSafari() {
          // Check for Safari.
          if (
            navigator.userAgent.indexOf('Safari') !== -1 &&
            navigator.userAgent.indexOf('Chrome') === -1
          ) {
            $('body').addClass('isSafari');
          }
        }

        function checkForFF() {
          // Check for Firefox.
          if (navigator.userAgent.search('Firefox') >= 0) {
            $('body').addClass('isFF');
          }
        }

        function checkForIEEleven() {
          // Check for IE.
          if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
            if ($('body').hasClass('isTouch')) {
              $('body').removeClass('isTouch');
            }
          }
        }

        function checkForMobileDevice() {
          // Check for mobile device
          if (
            /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
          ) {
            $('body').addClass('isMobile');
          }
        }

        function checkForIPad() {
          // Check for iPad.
          if (navigator.userAgent.match(/iPad/i) !== null) {
            $('body').addClass('isTouch');
          }
        }

        function makeBoutiqueChecks() {
          checkForIE();
          checkForSafari();
          checkForFF();
          checkForIEEleven();
          checkForMobileDevice();
          checkForIPad();
        }
        makeBoutiqueChecks();

        $(window).on('load', function () {
          // Remove the spinner.
          $('.boutiques_spinner_v1_target').fadeOut();

          // Fade out the spinner.Play video on first load only
          $('.boutiques_spinner_v1_target').fadeOut(400, function () {
            if ($.cookie('boutique_belle_video-cookie') === null) {
              $('#belle_mod1 .boutique_vid_play_img').trigger('click');
              $.cookie('boutique_belle_video-cookie', true);
            }
          });

          // Fade in modules for this boutique.
          // Init scrollMagic Controller Class
          var controller = new ScrollMagic.Controller();

          function fadeMod(faded, mod) {
            if (faded === false) {
              faded = true;
              mod.animate(
                {
                  opacity: 1,
                  paddingTop: '0'
                },
                350,
                'easeOutQuad'
              );
            } else {
              return;
            }
          }

          // Init scrollMagic Scene Classes
          var fadeModScene3 = new ScrollMagic.Scene({
            triggerElement: triggerMod3,
            offset: offsetVal
          }).on('start', function () {
            fadeMod(hasFadedMod3, mod3);
          });
          var fadeModScene4 = new ScrollMagic.Scene({
            triggerElement: triggerMod4,
            offset: offsetVal
          }).on('start', function () {
            fadeMod(hasFadedMod4, mod4);
          });
          var fadeModScene5 = new ScrollMagic.Scene({
            triggerElement: triggerMod5,
            offset: offsetVal
          }).on('start', function () {
            fadeMod(hasFadedMod5, mod5);
          });
          var fadeModScene6 = new ScrollMagic.Scene({
            triggerElement: triggerMod6,
            offset: offsetVal
          }).on('start', function () {
            fadeMod(hasFadedMod6, mod6);
          });

          // Add the scenes.
          controller.addScene([fadeModScene3, fadeModScene4, fadeModScene5, fadeModScene6]);
        });
      });
    }
  };
})(jQuery);
